'use client'

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { shoppingCardAction } from "../../store/reducers/shoppingCardSlice";

function Cart() {
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleOpen = () => {
    dispatch(shoppingCardAction(true));
  };
  const { cartTotalAmount, cartTotalQuantity } = useSelector(
    (state) => state.cart
  );

  if (!mounted) {
    // Render nothing or a placeholder on server or before hydration
    return null;
  }

  return (
    <>
      <button
        onClick={handleOpen}
        aria-label="Cart"
        className="absolute"
      >
        <div
          className="fixed top-1/2 right-0 -translate-y-1/2 z-30 hidden lg:flex flex-col items-center justify-center shadow-lg cursor-pointer rounded-tl-lg rounded-bl-lg bg-indigo-50 text-gray-700"
          style={{ width: "5rem" }} // smaller fixed width
        >
          <div className="flex flex-col items-center justify-center p-2 text-pink-600 text-2xl leading-none">
            <svg
              stroke="currentColor"
              fill="currentColor"
              strokeWidth="0"
              viewBox="0 0 512 512"
              height="1.4em"
              width="1.4em"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="32"
                d="M80 176a16 16 0 00-16 16v216c0 30.24 25.76 56 56 56h272c30.24 0 56-24.51 56-54.75V192a16 16 0 00-16-16zm80 0v-32a96 96 0 0196-96h0a96 96 0 0196 96v32"
              ></path>
              <path
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="32"
                d="M160 224v16a96 96 0 0096 96h0a96 96 0 0096-96v-16"
              ></path>
            </svg>
            <span className="text-xs font-medium truncate w-full text-center mt-1">
              {cartTotalQuantity} Items
            </span>
          </div>
          <div className="bg-pink-600 p-1 text-white text-sm font-medium rounded-bl-lg w-full text-center truncate">
            ₹{cartTotalAmount}
          </div>
        </div>
      </button>
    </>
  );
}

export default Cart;
